export const setBKDrop = state => ({
  type: 'BACKDROP_TOGGLE',
  state,
});

export const setSidebarState = state => ({
  type: 'SET_SIDEBAR_STATE',
  state,
});
